module.exports = __webpack_public_path__ + "8d1a16f432ee0b1b9770a73f0dae9bf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_65.jpg
// module id = 1787
// module chunks = 5